import React, { Suspense, useMemo, useState, useEffect } from 'react';
import { route } from '../Route';
import { SkeletonContainer } from '../components/Loader/Loader';
 
const Content = ({ currentLayoutLocation, openTabs = [],visitedPaths, setVisitedPaths }) => {
    const activeLocation = currentLayoutLocation === "/" ? "/employee-dashboard" : currentLayoutLocation;
 
    useEffect(() => {
        setVisitedPaths((prev) => {
            if (prev.has(activeLocation)) return prev;
            const next = new Set(prev);
            next.add(activeLocation);
            return next;
        });
    }, [activeLocation]);
 
    const allowedPaths = useMemo(() => {
        const paths = new Set();
        openTabs.forEach(tab => {
            if (!tab.isPermitted) return;
            if (tab.checkPath) {
                tab.checkPath.split(' ').map(p => p.trim()).filter(Boolean).forEach(p => paths.add(p));
            } else if (tab.to) {
                paths.add(tab.to);
            }
            if (tab.innerMenu) {
                tab.innerMenu.forEach(inner => {
                    if (!inner.isPermitted) return;
                    if (inner.to) paths.add(inner.to);
 
                    if (inner.subMenu) {
                        inner.subMenu.forEach(sub => {
                            if (sub.isPermitted && sub.to) paths.add(sub.to);
                        });
                    }
                });
            }
        });
 
        return paths;
    }, [openTabs]);
 
 
    const activeRoutesToRender = useMemo(() => {
        return route.filter(item => {
            if (!item.element || !item.path) return false;
 
            const isCurrentlyActive = item.path === activeLocation;
            const isAllowed = allowedPaths.has(item.path);
            const hasBeenVisited = visitedPaths?.has(item.path);
            return isCurrentlyActive || (isAllowed && hasBeenVisited);
        });
    }, [activeLocation, allowedPaths, visitedPaths]);

    return (
        <Suspense fallback={<SkeletonContainer />}>
            <div className="tabbed-content-container" style={{ width: '100%', height: '100%' }}>
                {activeRoutesToRender.map((item) => {
                    const isTabActive = activeLocation === item.path;
                    const Component = item.element;
 
                    return (
                        <div
                            key={item.path}
                            className={`tab-content-panel ${isTabActive ? 'active-panel' : 'inactive-panel'}`}
                            style={{
                                display: isTabActive ? 'block' : 'none',
                                width: '100%',
                                height: '100%'
                            }}
                        >
                            <Component />
                        </div>
                    );
                })}
            </div>
        </Suspense>
    );
};
 
export default Content;
